import { Injectable } from '@angular/core';
import { StrapiCollectionEntityByCityApiService } from '@core/data-access';
import { PhoneEntityStrapi } from '@main/phone/const';
import { filter, map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PhoneApiService extends StrapiCollectionEntityByCityApiService<PhoneEntityStrapi> {
  constructor() {
    super('manager-phones', 'cities');
  }

  getPhone(baseStoreCode: string): Observable<string> {
    return this.getListByCity(
      {
        pagination: { page: 1, pageSize: 1 },
      },
      baseStoreCode,
    ).pipe(
      map((phones) => phones?.[0].phone),
      filter(Boolean),
    );
  }
}
